import React, { useState, useEffect } from "react";

const UserContext = React.createContext(null);

const UserContextProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        // Cargar usuario desde localStorage al iniciar
        const storedUser = localStorage.getItem("user");
        return storedUser ? JSON.parse(storedUser) : null;
    });

    // Cada vez que cambia el usuario, lo guardamos
    useEffect(() => {
        if (user) {
            localStorage.setItem("user", JSON.stringify(user));
        } else {
            localStorage.removeItem("user");
        }
    }, [user]);

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};

export { UserContextProvider };
export default UserContext;